import { useEffect, useState } from 'react'
import { CompanyIssueDetails, ServicePage } from '../../shared'
import { getIssuers } from '../../shared/api/issuer.service'
import { getCompanyIssueInfo } from '../../shared/api/companyIssue.service'
import type { CompanyIssueInfo, IssuerOption } from '../../shared/types'

export function OpenExitOffer() {
  const [issuers, setIssuers] = useState<IssuerOption[]>([])
  const [company, setCompany] = useState('')
  const [details, setDetails] = useState<CompanyIssueInfo | null>(null)
  const [error, setError] = useState('')

  useEffect(() => {
    void getIssuers('openExit')
      .then((rows) => {
        setIssuers(rows)
        setError(rows.length === 0 ? 'No companies are available for this service.' : '')
      })
      .catch((loadError: unknown) => {
        setIssuers([])
        setError(loadError instanceof Error ? loadError.message : 'Could not load companies.')
      })
  }, [])

  useEffect(() => {
    if (!company) {
      setDetails(null)
      return
    }

    const controller = new AbortController()
    setError('')
    void getCompanyIssueInfo('openExit', company, controller.signal)
      .then(setDetails)
      .catch((loadError: unknown) => {
        if (!controller.signal.aborted) {
          setDetails(null)
          setError(loadError instanceof Error ? loadError.message : 'Could not load company details.')
        }
      })
    return () => controller.abort()
  }, [company])

  return (
    <ServicePage current="openOffer">
      <div className="mb-3">
        <label className="form-label" htmlFor="oe-company">
          Company:
        </label>
        <select
          id="oe-company"
          className="form-select"
          value={company}
          onChange={(event) => setCompany(event.target.value)}
        >
          <option value="">*** Select ***</option>
          {issuers.map((issuer) => (
            <option key={issuer.value} value={issuer.value}>
              {issuer.label}
            </option>
          ))}
        </select>
      </div>
      {error ? <p className="form-message-error">{error}</p> : null}
      {details ? <CompanyIssueDetails details={details} /> : null}
    </ServicePage>
  )
}
